import { useState } from 'react';

const useWeChatQR = () => {
  const [openQR, setOpenQR] = useState(false);

  const openWeChatQR = () => setOpenQR(true);
  const closeWeChatQR = () => setOpenQR(false);

  return {
    openQR,
    openWeChatQR,
    closeWeChatQR,
  };
};

export default useWeChatQR; 